import { Divider } from '@mui/material'
import { useTheme } from '@mui/material/styles'

function CustomDivider() {
  const theme = useTheme()
  return <Divider sx={{ mt: 1.25, mb: 1.25, borderColor: theme.palette.primary.light }}/>
}

export default CustomDivider
